const ProductActiveStatus = {
  Inactive: 'Inactive',
  Active: 'Active',
  Archived: 'Archived',
  Discontinued: 'Discontinued',
};

const ProductActiveStatusOptions = [
  { value: ProductActiveStatus.Inactive, label: 'Inactive' },
  { value: ProductActiveStatus.Active, label: 'Active' },
  { value: ProductActiveStatus.Archived, label: 'Archived' },
  { value: ProductActiveStatus.Discontinued, label: 'Discontinued' },
];

export { ProductActiveStatus, ProductActiveStatusOptions };
